import { Eye, EyeOff } from "lucide-react";

import { ColocaIconButton } from "@/shared/components/buttons/ColocaIconButton";
import { useBalancesHidden } from "@/shared/hooks/useBalancesHidden";
import useTranslations from "@/shared/lang/useTranslations";

export function BalanceVisibilityToggle() {
  const { t } = useTranslations("wallets");
  const { hidden, toggle } = useBalancesHidden();
  const label = hidden ? t("balance_show_aria") : t("balance_hide_aria");

  return (
    <ColocaIconButton
      icon={hidden ? EyeOff : Eye}
      variant="ghost"
      size="sm"
      onClick={toggle}
      aria-label={label}
      aria-pressed={hidden}
      title={label}
      className="shrink-0 text-muted-foreground"
    />
  );
}
